import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { ActivatedRoute, Router, } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { PageMetadataRegistry } from '@app/router';
import { UpsertPageComponent, } from '@components';
import { ParameterValidators, UiParameterCollectionComponent, } from '@components/shared/ui-parameter-collection/ui-parameter-collection.component';
import { JobStartStrategy, StopStrategy, TriggerType, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { MAX_NUMBER_OF_JOBS, MAX_NUMBER_OF_ROBOTS, } from '@pages/shared/constants';
import { TriggerUpsertPageService } from '@pages/triggers/upsert/trigger.upsert.page.service';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import { UiSuggestComponent } from '@uipath/angular/components/ui-suggest';
import { decodeParams } from '@utils/encode.utils';
import { getProperty } from '@utils/object.utils';
import UiValidators from '@validators';
import { filter, finalize, map, switchMap, takeUntil, tap, } from 'rxjs/operators';
import { ITEMS_ACTIVATION_MAX, ITEMS_PER_JOB_ACTIVATION_MAX, MAX_JOBS_ACTIVATION_MAX, QUEUE_TRIGGER_SPECIFIC_FIELDS, START_STRATEGY, START_STRATEGY_JOB_MIN_NO_OF_JOBS, STOP_DAYS_MAX, STOP_HOURS_MAX, STOP_MINUTES_MAX, TIME_TRIGGER_SPECIFIC_FIELDS, TRIGGER_FORM_FIELDS, TRIGGER_MAX_NAME_LENGTH, TRIGGER_TYPES, } from './trigger.upsert.page.models';
var TriggerUpsertPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TriggerUpsertPageComponent, _super);
    function TriggerUpsertPageComponent(_route, _router, _appState, _fb, _snack, _upsertService, _translate, _pageRegistry, _cd) {
        var _this = _super.call(this, _route, _router, _appState) || this;
        _this._fb = _fb;
        _this._snack = _snack;
        _this._upsertService = _upsertService;
        _this._translate = _translate;
        _this._pageRegistry = _pageRegistry;
        _this._cd = _cd;
        _this.fields = TRIGGER_FORM_FIELDS;
        _this.startNoOfJobs = START_STRATEGY_JOB_MIN_NO_OF_JOBS;
        _this.maxNoOfJobs = MAX_NUMBER_OF_JOBS;
        _this.maxNoOfRobots = MAX_NUMBER_OF_ROBOTS;
        _this.JobStartStrategy = JobStartStrategy;
        _this.StopStrategy = StopStrategy;
        _this.processChangeDisabled = false;
        _this.timezones = [];
        _this.calendarNames = [];
        _this.disableQueueTrigger$ = _this._appState.user.permissions
            .isGranted('Queues.View')
            .pipe(map(function (permission) { return !permission; }));
        _this.hasRobotsViewPermissions$ = _this._appState.user.permissions
            .isGranted('Robots.View');
        _this.triggerOptions$ = _this.disableQueueTrigger$.pipe(map(function (disableQueueTrigger) { return TRIGGER_TYPES
            .map(function (type) {
            if (type.id === TriggerType.Queue) {
                type.disabled = disableQueueTrigger;
            }
            return type;
        }); }));
        _this.processSuggest$ = _this._upsertService.processesSuggest$;
        _this._initialContext$ = [
            _this._upsertService.getTimezones()
                .pipe(tap(function (timezones) { return _this.timezones = timezones; })),
        ];
        _this._getInstance = function () {
            return _this._upsertService.getInstanceData(_this.id, _this.timezones);
        };
        _this._changedQueue = function (_a) {
            var selected = _a[0];
            if (!selected || _this.isTimeTrigger) {
                _this.processChangeDisabled = false;
                return;
            }
            _this._upsertService.getQueueDefinition(selected.id)
                .pipe(tap(function (queue) {
                // FIXME: get rid of this, we should mark the form fields as disabled, not the widgets
                _this.processChangeDisabled = queue.slaMinutes > 0;
                _this._cd.detectChanges();
            }), filter(function (queue) { return queue.releaseId != null; }), switchMap(function (queue) { return _this._upsertService.getProcess(queue.releaseId); }), takeUntil(_this._destroyed$))
                .subscribe(function (queueProcess) {
                var processControl = _this.getField('process');
                var processValue = processControl.value && processControl.value[0];
                if (processValue && processValue.id === queueProcess.id) {
                    return;
                }
                processControl.setValue([{
                        data: queueProcess,
                        id: queueProcess.id,
                        text: queueProcess.name,
                    }]);
            });
        };
        _this._changedProcess = function (_a) {
            var selected = _a[0];
            if (!selected) {
                return;
            }
            _this._formContext.environmentId = selected.data.environmentId;
            var inputArgs = _this.getField('inputArguments');
            // reset previous values and validators if any
            inputArgs.clearValidators();
            inputArgs.setValue(_this.defaults.inputArguments);
            _this._addParametersValidator();
        };
        _this._maxNoOfJobsDynamicValidator = function (startStrategyFormControl) {
            if (!_this.form || !_this.isTargetJobsCount) {
                return null;
            }
            return Validators.compose([
                UiValidators.range(1, _this.maxNoOfJobs, true),
                UiValidators.required(),
            ])(startStrategyFormControl);
        };
        _this._nonNullIntervalValidator = function () {
            if (!_this.form || !_this.getField('stopEnabled').value) {
                return null;
            }
            var stopFields = _this.getFields('stopDays', 'stopHours', 'stopMinutes');
            return !stopFields.find(function (f) { return f.value > 0; }) ?
                { zeroMinutes: true } :
                null;
        };
        _this._requiredRobotsValidator = function () {
            if (!_this.form || !_this.isTargetSpecificRobots) {
                return null;
            }
            var selectedRobots = _this.getField('executorRobots').value;
            return selectedRobots.length === 0 ?
                { requiredRobotsNotSelected: true } :
                null;
        };
        _this._setFormContext();
        return _this;
    }
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "defaults", {
        get: function () {
            return {
                type: this._formContext.type,
                name: '',
                enabled: true,
                useCalendar: false,
                externalJobKey: '',
                environmentId: NaN,
                // cron junk
                startProcessCron: '',
                startProcessCronDetails: null,
                disableAfter: false,
                stopProcessDate: null,
                startStrategy: -1,
                startStrategyRadio: JobStartStrategy.AllRobots,
                executorRobots: [],
                inputArguments: {},
                itemsActivationThreshold: 1,
                itemsPerJobActivationTarget: 1,
                maxJobsForActivation: 1,
                stopEnabled: false,
                stopDays: 0,
                stopHours: 0,
                stopMinutes: 0,
                stopStrategy: null,
                calendar: this.isMultipleCalendarsEnabled ?
                    this._defaultCalendar : undefined,
                queue: this._defaultQueueFormContext,
                timezone: this._defaultTimezone,
                process: this._defaultProcessFormContext,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "validators", {
        get: function () {
            return {
                name: Validators.compose([
                    UiValidators.required(),
                    Validators.maxLength(TRIGGER_MAX_NAME_LENGTH),
                ]),
                process: UiValidators.required(),
                timezone: UiValidators.required(),
                startStrategy: this._maxNoOfJobsDynamicValidator,
                stopDays: UiValidators.range(0, STOP_DAYS_MAX),
                stopHours: UiValidators.range(0, STOP_HOURS_MAX),
                stopMinutes: UiValidators.range(0, STOP_MINUTES_MAX),
                queue: UiValidators.required(),
                itemsActivationThreshold: UiValidators.range(1, ITEMS_ACTIVATION_MAX),
                itemsPerJobActivationTarget: UiValidators.range(1, ITEMS_PER_JOB_ACTIVATION_MAX),
                maxJobsForActivation: UiValidators.range(1, MAX_JOBS_ACTIVATION_MAX),
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "isSubmitDisabled", {
        get: function () {
            return this._isSubmitDisabled ||
                !!this.parameterCollectionGrid &&
                    this.parameterCollectionGrid.isOpen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "timezone", {
        get: function () {
            return this._translate.instant('trigger_modal_timezone_info', {
                timezone: this.getField('timezone').value[0].text ||
                    this._translate.instant('trigger_modal_timezone_server_time'),
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "environmentId", {
        get: function () {
            return this._formContext.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "isTimeTriggerContext", {
        get: function () {
            return this._formContext.type === TriggerType.Time;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "isTenantTimezone", {
        get: function () {
            var timezone = this.getField('timezone').value[0];
            return timezone &&
                this._upsertService.timezoneId === timezone.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "isMultipleCalendarsEnabled", {
        get: function () {
            return this._upsertService.isMultipleCalendarsEnabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "isTimeTrigger", {
        get: function () {
            if (!this.form) {
                return false;
            }
            var type = this.getField('type').value;
            return !!type && type === TriggerType.Time;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "isTargetSpecificRobots", {
        get: function () {
            if (!this.form) {
                return false;
            }
            return this.getField('startStrategyRadio').value === JobStartStrategy.SpecificRobots;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "isTargetJobsCount", {
        get: function () {
            if (!this.form) {
                return false;
            }
            return this.getField('startStrategyRadio').value === JobStartStrategy.JobsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "paramCollectionInput", {
        get: function () {
            if (!this.form ||
                !this.getField('process').value.length) {
                return [];
            }
            var process = this.getField('process');
            return process.value[0].data.arguments.input || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "_defaultQueueFormContext", {
        get: function () {
            return this._formContext.queue ?
                [{
                        id: this._formContext.queue.id,
                        text: this._formContext.queue.name,
                    }] :
                [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "_defaultProcessFormContext", {
        get: function () {
            return this._formContext.process ?
                [{
                        id: this._formContext.process.id,
                        text: this._formContext.process.name,
                        data: this._formContext.process.data,
                    }] :
                [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "_defaultTimezone", {
        get: function () {
            var _this = this;
            return this.timezones ?
                [this.timezones.find(function (tz) { return tz.id === _this._upsertService.timezoneId; })] :
                [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "_defaultCalendar", {
        get: function () {
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggerUpsertPageComponent.prototype, "_submit$", {
        get: function () {
            if (!this.form) {
                throw new Error('Form is undefined');
            }
            if (!this.isTimeTrigger) {
                // FIXME: CRON - for queue trigger ensure we send the default cron ...
                this.startProcessCronObj = this._upsertService.parseCron();
            }
            this.startProcessCronObj.normalize();
            var trigger = tslib_1.__assign({}, this.form.value, { 
                // FIXME: CRON
                startProcessCronDetails: JSON.stringify(this.startProcessCronObj), startProcessCron: this.startProcessCronObj.cronExpression });
            // ensure we reset executorRobots if strategy is not SpecificRobots
            // this is not handled within the form in order to persist selected state
            //  if user switches between strategies or types
            if (trigger.startStrategyRadio !== JobStartStrategy.SpecificRobots) {
                trigger.executorRobots = [];
            }
            return this.isEditMode ?
                this._upsertService.update(this.id, trigger) :
                this._upsertService.add(trigger);
        },
        enumerable: true,
        configurable: true
    });
    TriggerUpsertPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this._appState.user
            .folder
            .change$.pipe(tap(function () {
            if (_this.isEditMode) {
                _this._forceNavigateBaseUrl();
                return;
            }
            _this.getFields('process', 'queue')
                .forEach(function (f) { return f.setValue([]); });
            _this._formContext = {
                type: _this.getField('type').value,
            };
        }), takeUntil(this._destroyed$)).subscribe();
    };
    TriggerUpsertPageComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.isSubmitDisabled) {
            return;
        }
        this.loading$.next(true);
        this._submit$.pipe(finalize(function () { return _this.loading$.next(false); })).subscribe(function () {
            _this._snack.success(_this._translate.instant('save_successful'));
            _this._forceNavigateBaseUrl();
        }, function (error) {
            if (error.status === 403) {
                _this._forceNavigateBaseUrl();
            }
        });
    };
    TriggerUpsertPageComponent.prototype.changedTrigger = function (newTrigger) {
        var isTimeTrigger = newTrigger === TriggerType.Time;
        this._updateTriggerTypeFields(isTimeTrigger);
        if (!isTimeTrigger) {
            // queue trigger cannot have stopJob enabled
            this.getField('stopEnabled').setValue(false);
            // ensure that any other types have the start strategy set to all robots
            this.getField('startStrategy').setValue(-1);
            this.getField('startStrategyRadio').setValue(JobStartStrategy.AllRobots);
        }
        else {
            // disabling process change is only valid for queue triggers
            this.processChangeDisabled = false;
        }
        this.getField('type').markAsPristine();
    };
    TriggerUpsertPageComponent.prototype.changedDisableAfter = function (disableAfter) {
        var stopProcessDate = this.getField('stopProcessDate');
        if (disableAfter) {
            stopProcessDate.enable();
        }
        else {
            stopProcessDate.disable();
            stopProcessDate.setValue(null);
        }
    };
    TriggerUpsertPageComponent.prototype.changedStrategy = function (_a) {
        var value = _a.value;
        this.getField('startStrategy')
            .setValue(START_STRATEGY.get(value));
    };
    TriggerUpsertPageComponent.prototype.changedTimezone = function (newTimezone) {
        if (this._upsertService.timezoneId === newTimezone.id) {
            return;
        }
        this.getField('useCalendar').setValue(false);
    };
    TriggerUpsertPageComponent.prototype.changedCalendar = function (calendar) {
        this.getField('useCalendar').setValue(!!calendar);
    };
    TriggerUpsertPageComponent.prototype._initForm = function (controlsConfig, _, trigger) {
        var _this = this;
        if (trigger) {
            this._pageRegistry.setCustomTitle(trigger.name);
            this._formContext.environmentId = trigger.environmentId;
            this._formContext.type = trigger.type;
        }
        this.startProcessCronObj = this._upsertService
            .parseCron(trigger ?
            trigger.startProcessCronDetails :
            undefined);
        var configCalendarId = getProperty(controlsConfig, 'calendar.0.0.id');
        var defaultCalendarValue = this.isMultipleCalendarsEnabled ?
            [this.calendarNames.filter(function (calendar) { return calendar.id === configCalendarId; })] :
            undefined;
        this.form = this._fb.group(tslib_1.__assign({}, controlsConfig, { calendar: defaultCalendarValue, 
            // FIXME: refactor cron :(
            cron: this._fb.group({
                minutelyAtMinute: [[]],
                hourlyEveryHours: [this.startProcessCronObj.hourly.frequencyInHours],
                hourlyAtMinute: [this.startProcessCronObj.hourly.atMinute],
                dailyAtHour: [this.startProcessCronObj.daily.atHour],
                dailyAtMinute: [this.startProcessCronObj.daily.atMinute],
                weeklyAtHour: [this.startProcessCronObj.weekly.atHour],
                weeklyAtMinute: [this.startProcessCronObj.weekly.atMinute],
                monthlyAtHour: [this.startProcessCronObj.monthly.atHour],
                monthlyAtMinute: [this.startProcessCronObj.monthly.atMinute],
                monthlyFrequency: [this.startProcessCronObj.monthly.frequencyInMonths],
                advancedCron: [this.startProcessCronObj.advancedCronExpression],
            }) }), {
            validator: Validators.compose([
                this._nonNullIntervalValidator,
                this._requiredRobotsValidator,
            ]),
        });
        this._updateTriggerTypeFields(this.isTimeTriggerContext);
        var queue = this.getField('queue');
        queue.valueChanges
            .pipe(takeUntil(this._destroyed$)).subscribe(this._changedQueue);
        var process = this.getField('process');
        process.valueChanges
            .pipe(takeUntil(this._destroyed$)).subscribe(this._changedProcess);
        this._addParametersValidator();
        if (!this.isTimeTrigger) {
            this.getField('queue').updateValueAndValidity();
        }
        this.disableQueueTrigger$.pipe(filter(Boolean), tap(function () {
            var type = _this.getField('type');
            if (type.value !== TriggerType.Queue) {
                return;
            }
            if (_this.isEditMode) {
                _this._snack.error(_this._translate.instant('page_access_denied'));
                _this._forceNavigateBaseUrl();
                return;
            }
            type.setValue(TriggerType.Time);
        }), takeUntil(this._destroyed$)).subscribe();
        this.loading$.next(false);
    };
    TriggerUpsertPageComponent.prototype._addParametersValidator = function () {
        var processValue = this.getField('process').value;
        if (!processValue.length) {
            return;
        }
        var data = processValue[0].data;
        if (data.arguments) {
            var inputArgs = this.getField('inputArguments');
            inputArgs.setValidators(ParameterValidators.required(data.arguments.input));
            inputArgs.updateValueAndValidity();
        }
    };
    TriggerUpsertPageComponent.prototype._updateTriggerTypeFields = function (isTimeTrigger) {
        var queueInputs = QUEUE_TRIGGER_SPECIFIC_FIELDS;
        var timeInputs = TIME_TRIGGER_SPECIFIC_FIELDS.concat([
            // FIXME: refactor cron
            'cron',
        ]);
        if (isTimeTrigger) {
            this.disableFields.apply(this, queueInputs);
            this.enableFields.apply(this, timeInputs);
        }
        else {
            this.enableFields.apply(this, queueInputs);
            this.disableFields.apply(this, timeInputs);
        }
    };
    TriggerUpsertPageComponent.prototype._setFormContext = function () {
        var _this = this;
        var queue = this._route.snapshot.queryParamMap.get('queue');
        var process = this._route.snapshot.queryParamMap.get('process');
        var type = this._route.snapshot.queryParamMap.get('type');
        this._formContext = tslib_1.__assign({ type: type !== null ?
                Number(type) :
                TriggerType.Time }, (queue ? { queue: decodeParams(queue) } : {}), (process ? { process: decodeParams(process) } : {}));
        if (this._formContext.process) {
            this._initialContext$.push(this._upsertService
                .getProcess(this._formContext.process.id).pipe(tap(function (p) { return _this._formContext.process.data = p; })));
        }
        if (this._formContext.queue) {
            this._initialContext$.push(this._upsertService.getQueueDefinition(this._formContext.queue.id).pipe(tap(function (q) { return _this._formContext.queue.data = q; })));
        }
        this._initialContext$.push(this._upsertService
            .getCalendarNames().pipe(tap(function (calendars) { return _this.calendarNames = calendars; })));
    };
    return TriggerUpsertPageComponent;
}(UpsertPageComponent));
export { TriggerUpsertPageComponent };
